<div class="signature-container">
  @if (label()) {
    <div class="signature-header">
      <span class="signature-label">{{ label() }}</span>
    </div>
  }
  <div class="canvas-wrapper">
    <canvas
      #signatureCanvas
      [width]="width()"
      [height]="height()"
      class="signature-canvas"
    ></canvas>
    @if (!hasSignature()) {
      <div class="placeholder-text">Sign here</div>
    }
  </div>
</div>
